import { createSlice } from '@reduxjs/toolkit';

export const categoryToUpdateSlice = createSlice({
  name: 'categoryToUpdate',
  initialState: '',
  reducers: {
    setCategoryToUpdate: (state, action) => action.payload,
    resetCategoryToUpdate: () => '',
  },
});

export const { setCategoryToUpdate, resetCategoryToUpdate } =
  categoryToUpdateSlice.actions;

export default categoryToUpdateSlice.reducer;
